module.exports = __webpack_public_path__ + "static/media/pacRoyale-gameplay2.eb3bf3ae.png";